module.exports = "<p>\n  request-form-receipts works!\n</p>\n"